import React from 'react';
import { Container } from 'reactstrap';
import SpotlightSegmentsPage from './SpotlightSegmentsPage';

// Segments, on their own page (sidebar: Users > Segments)
const SegmentsPage = () => (
  <Container>
    <SpotlightSegmentsPage />
  </Container>
);

export default SegmentsPage;
